export default {
	xingaokao: "湖南省,广东省,江苏省,湖北省,福建省,重庆市,辽宁省,天津市,浙江省,河北省,山东省",
	xingaokao2: "湖南省,广东省,江苏省,湖北省,福建省",
	xingaokao3: "天津市",
	xingaokao4: "辽宁省,重庆市,河北省",
	xingaokao5: "山东省",
	xingaokao6: "浙江省",
	yishuarea: "黑龙江省,湖南省,四川省,辽宁省,湖北省,安徽省,广西壮族自治区,重庆市,广东省",
	level: ["985", "211", "双一流", "国重点", "国研究生院", "校研究生院","国一流专业", "省双一流",
		"省重点", "省部共建", "中外合作", "区域一流", "区域高水平", "区域知名", "军事院校", "国重点专科", "国示范高职", "国骨干高职",
		"省重点专科","省示范高职"
	],
  //,"国防七子","兵工七子","五院四系","双高计划"
	level1: ["985", "211", "双一流A类", "国重点", "国研究生院", "双一流学科", "校研究生院", "世界一流", "国一流专业", "省双一流", "世界知名", "双一流", "双一流B类",
		"省部合作", "部属院校", "省重点", "省部共建", "中国一流", "中国高水平", "国内高水平", "中外合作", "区域一流", "省属重点", "军事重点", "世界高水平", "区域高水平",
		"国内一流学科", "国一流学科", "部属高校", "区域知名", "卓越工程师", "国双一流", "民办", "省一流学科", "军事院校", "专科", "国重点专科", "国示范高职", "国骨干高职",
		"国优质高职", "省重点专科", "省骨干高职", "省示范高职", "省重点高职", "省示范院校", "省优质高职", "国优质专科"
	],
	subjection: ["教育部", "工业和信息化部","公安部","国家民族事务委员会","交通运输部","中国科学院","中国人民解放军"]
}



// WEBPACK FOOTER //
// ./src/libs/common.js